<template>
  <div class="page border-box"  v-wechat-title="$route.meta.title='万物有声'">
    <div class="noData" v-if="shopsList.length<=0 && loadEnd">
      <img src="../../assets/noData.png" alt="">
    </div>

    <!--<router-link class="list_li" :to="{path:'/study',query: {id: item.id,TimeStamp: TimeStamp, appKey: appKeyA}}">-->
    <router-link class="list_li" :to="{path:'/study-activity-01',query: {TimeStamp: TimeStamp, appKey: appKeyA}}">
      <img class="img" src="../../assets/gz-img01.png" alt="">
    </router-link>
    <router-link class="list_li" :to="{path:'/study-activity-02',query: {TimeStamp: TimeStamp, appKey: appKeyA}}">
      <img class="img" src="../../assets/gz-img03.png" alt="">
    </router-link>
    <div class="list_li" @click="toStudyActivity()">
      <img class="img" src="../../assets/gz-img02.png" alt="">
    </div>


  </div>

</template>

<script>
  import {getStudyList} from "@/service/getData";
  import {wxGetPosition,wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore,loadMore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        userInfo: {}, //用户信息
        loadEnd: false, //数据加载结束则赋值为true
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        shopsList:[],//景点列表
        shopsTotal:'',//景点总数
        loadText: "数据加载中",
        page: 1,
        rows: 10,
      }
    },
    computed: {},
    created(){
      this.global.set_glabalClear()
      let self = this;
//      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      this.id = this.$route.query.id;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }
      this.userInfo = getStore("userInfo");
      this.initData();
    },
    methods: {
      //初始化：获取研学首页数据
      initData(){
        let title = '金牌解说 | 万物有声';
        let desc = '金牌解说邀您参与文化研学，听解说！讲故事！弘扬历史文化！';
        let link = '/study-activity-gz?siteid='+this.$route.query.siteid+'&TimeStamp'+this.TimeStamp +'&appKey=' + (this.appKey);
        wxShareme(title,desc,"",link);
      },


      toStudyActivity(){
        this.$toast("当前活动暂未开启")
      },


    },

  }

</script>

<style scoped>
  .page{min-height:100vh;padding:.6rem .36rem 1.2rem;background: #fff;}
  .noData img{ display: block; width: 50.27%; margin: 16% auto 0; }
  .list_li{position:relative;display: block;width: 100%;height: 3.2rem;margin-bottom:.18rem;border-radius: .16rem;overflow: hidden;}
  .list_li_txt{position: absolute;top: 0;left: 0;width: 100%;height: 100%;padding:0 .24rem;background: rgba(0,0,0,.5);}
  .list_li_txt span{position:absolute;top:50%;left:0;width:100%;font: bold .38rem/.5rem "Microsoft YaHei";letter-spacing:.05rem;color: #fff;text-align: center;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .list_li img{width: 100%;height: 100%;border-radius: .16rem;object-fit: cover;}
</style>



// WEBPACK FOOTER //
// src/page/study-activity-gz/study-activity-gz.vue